import Chart from "pro-features/components/Chart/src/Chart";
import { getChartConfig } from "app/components/React/MarketingChannelsDistribution/chartConfig";
import {
    ChartContainerSingle,
    MarketingChannelsDistributionContainer,
    Text,
} from "app/components/React/MarketingChannelsDistribution/styledComponents";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { i18nFilter } from "app/filters/i18nFilter";
import { chartTypes } from "app/UtilitiesAndConstants/Constants/ChartTypes";
import { constants } from "app/components/React/MarketingChannelsDistribution/constants";
import { colorsPalettes } from "@similarweb/styles";

const noDataConstants = {
    DEFAULT_COLUMN_COLOR: colorsPalettes.carbon[100],
    NO_DATA_TEXT_KEY: "marketing.channels.distribution.no.data",
};

const placeholderValues = Object.keys(constants).map(() => {
    const MINIMUM_VALUE = 0.1;
    return Math.max(Math.random(), MINIMUM_VALUE);
});

export const NoData = (props) => {
    const { marketingChannelsType } = props;
    const { NO_DATA_TEXT_KEY, DEFAULT_COLUMN_COLOR } = noDataConstants;
    const chartData = Object.entries(constants).map((item, index) => {
        const { COLOR: itemColor, DISPLAY_NAME_KEY } = item[1];
        const id = item[0];
        return {
            displayName: i18nFilter()(DISPLAY_NAME_KEY),
            y: placeholderValues[index],
            color: id === String(marketingChannelsType) ? itemColor : DEFAULT_COLUMN_COLOR,
        };
    });
    const chartConfig = getChartConfig(chartData, false);
    const replacementObject = {
        trafficSource: i18nFilter()(constants[marketingChannelsType].DISPLAY_NAME_KEY),
    };
    return (
        <MarketingChannelsDistributionContainer>
            <Text>
                <I18n dataObj={replacementObject}>{NO_DATA_TEXT_KEY}</I18n>
            </Text>
            <ChartContainerSingle>
                <Chart
                    type={chartTypes.COLUMN}
                    data={chartData}
                    config={chartConfig}
                />
            </ChartContainerSingle>
        </MarketingChannelsDistributionContainer>
    );
};
